import React, { forwardRef } from 'react';
import classnames from 'classnames';

export interface TextAreaProps {
  testId?: string;
  status?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'warning'
    | 'success'
    | 'info'
    | 'dark';
  placeholder?: string;
  type?: string;
  disabled?: boolean;
  className?: string;
  name: string;
  controlling?: boolean;
  value?: string;
  rows?: number;
  maxWidth?: boolean;
  minWidth?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  defaultValue?: string;
  maxLength?: number;
}

// eslint-disable-next-line react/display-name
export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    {
      testId,
      name,
      status,
      className = '',
      disabled,
      controlling,
      value,
      onChange,
      defaultValue,
      placeholder = 'Enter a description...',
      rows = 5,
      minWidth,
      maxWidth,
      maxLength,
      ...props
    }: TextAreaProps,
    ref,
  ) => {
    return (
      <textarea
        data-testid={testId}
        ref={ref}
        {...props}
        name={name}
        className={classnames(
          `textarea textarea-${status} d-flex align-items-start align-self-stretch w-100 shadow-xs p-6 pointer`,
          {
            'textarea-disabled': disabled,
            'input-min-width': minWidth,
            'input-max-width': maxWidth,
            'bg-white': !disabled,
          },
          className,
        )}
        rows={rows}
        disabled={disabled}
        defaultValue={defaultValue}
        placeholder={placeholder}
        maxLength={maxLength}
        {...(controlling && { value: value, onChange: onChange })}
      ></textarea>
    );
  },
);
